// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { NextFilesPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Files extends APIResource {
    /**
     * Get the files attached to an agent with their open/closed status.
     */
    list(agentID, query = {}, options) {
        return this._client.getAPIList(path `/v1/agents/${agentID}/files`, (NextFilesPage), {
            query,
            ...options,
        });
    }
    /**
     * Closes a specific file for a given agent.
     *
     * This endpoint marks a specific file as closed in the agent's file state. The
     * file will be removed from the agent's working memory view.
     */
    close(fileID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/files/${fileID}/close`, options);
    }
    /**
     * Closes all currently open files for a given agent.
     *
     * This endpoint updates the file state for the agent so that no files are marked
     * as open. Typically used to reset the working memory view for the agent.
     */
    closeAll(agentID, options) {
        return this._client.patch(path `/v1/agents/${agentID}/files/close-all`, options);
    }
    /**
     * Opens a specific file for a given agent.
     *
     * This endpoint marks a specific file as open in the agent's file state. The file
     * will be included in the agent's working memory view. Returns a list of file
     * names that were closed due to LRU eviction.
     */
    open(fileID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/files/${fileID}/open`, options);
    }
}
//# sourceMappingURL=files.mjs.map